import { render } from "./AlsoFound.vue?vue&type=template&id=4034ec08"
import script from "./AlsoFound.vue?vue&type=script&lang=js"
export * from "./AlsoFound.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__